import { render } from "./FormSurveyHeader.vue?vue&type=template&id=483de7ee&scoped=true"
import script from "./FormSurveyHeader.vue?vue&type=script&lang=js"
export * from "./FormSurveyHeader.vue?vue&type=script&lang=js"

import "./FormSurveyHeader.vue?vue&type=style&index=0&id=483de7ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-483de7ee"

export default script